/**
 * Utilidades para mantener abierto el preview al pasar el mouse de la miniatura al panel.
 */
export const createPreviewHoverHandlers = ({
    showTimeoutRef,
    hideTimeoutRef,
    showDelayMs = 150,
    hideDelayMs = 180,
    onAnchorSet,
    onShowPreview,
    onHide,
}) => {
    const isOverPreviewRef = { current: false };

    const clearShowTimeout = () => {
        if (showTimeoutRef.current) {
            clearTimeout(showTimeoutRef.current);
            showTimeoutRef.current = null;
        }
    };

    const clearHideTimeout = () => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
    };

    const clearAllPreviewTimeouts = () => {
        clearShowTimeout();
        clearHideTimeout();
    };

    const scheduleHide = () => {
        clearShowTimeout();
        clearHideTimeout();
        hideTimeoutRef.current = setTimeout(() => {
            hideTimeoutRef.current = null;
            if (!isOverPreviewRef.current) {
                onHide();
            }
        }, hideDelayMs);
    };

    const handlePhotoMouseEnter = (photo, event) => {
        clearHideTimeout();
        clearShowTimeout();
        onAnchorSet({ x: event.clientX, y: event.clientY });
        showTimeoutRef.current = setTimeout(() => {
            showTimeoutRef.current = null;
            onShowPreview(photo);
        }, showDelayMs);
    };

    const handlePhotoMouseLeave = () => {
        scheduleHide();
    };

    const handlePreviewHoverChange = (isHovered) => {
        isOverPreviewRef.current = isHovered;
        if (isHovered) {
            clearHideTimeout();
            return;
        }
        scheduleHide();
    };

    return {
        handlePhotoMouseEnter,
        handlePhotoMouseLeave,
        handlePreviewHoverChange,
        clearAllPreviewTimeouts,
    };
};
